import cn from 'classnames';

import OPE from 'js/on-page-editing';
import { SatelliteHeader_TextColorMap, getEnumStringValue } from 'js/utils/enum-string-maps';

import ContentContainer from 'components/content-container/ContentContainer';
import Image from 'components/image/Image';
import { imageSizes } from 'components/image/image-sizes';
import Link from 'components/link/Link';
import Map from 'components/map/Map';

import { ISatelliteHeader } from 'source/NFR.types';

const SatelliteHeader: React.FC<ISatelliteHeader> = ({
  image,
  ingress,
  links = [],
  map,
  onPageEditing,
  title,
  text,
  textColor
}) => {
  return (
    <div className="satellite-header">
      <div
        className={cn('satellite-header__top', {
          'satellite-header__top--large': !!image || !!links.length
        })}
      >
        {map && <Map {...map} />}
        {image && (
          <Image
            className="satellite-header__image"
            {...imageSizes.satelliteHeader}
            {...image}
            loading="eager"
            fetchPriority="high"
          />
        )}
        <ContentContainer className="satellite-header__content">
          {text && (
            <h2
              className={cn('satellite-header__lead', getEnumStringValue(SatelliteHeader_TextColorMap, textColor))}
              {...OPE(onPageEditing?.text)}
            >
              {text}
            </h2>
          )}
          {!!links.length && (
            <div className="satellite-header__links" {...OPE(onPageEditing?.links)}>
              {links?.map(link => (
                <Link
                  className="satellite-header__link"
                  key={link.url}
                  useButtonStyles={true}
                  theme="primary"
                  {...link}
                />
              ))}
            </div>
          )}
        </ContentContainer>
      </div>
      <div className="satellite-header__bottom">
        {title && (
          <h1 className="satellite-header__title" {...OPE(onPageEditing?.title)}>
            {title}
          </h1>
        )}
        {ingress && (
          <p className="satellite-header__ingress" {...OPE(onPageEditing?.ingress)}>
            {ingress}
          </p>
        )}
      </div>
    </div>
  );
};

SatelliteHeader.displayName = 'SatelliteHeader';

export default SatelliteHeader;
